<header class="position__relative header_container">
  <img class="hero_header_img" src="assets/img/consultoria33.jpg">

  <div class="header_text scroll-animations container-fluid">
    <div class="header_text_container position__relative">
      <h1 class="header_title animated mb-3">PROYECTOS</h1>
    </div>
  </div>
</header>

<section class="position__relative">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12">
        <div class="header_nav scroll-animations row">

          @for (section of sections; track section) {
            <div class="nav_tabs col-12 col-sm-4 col-md-4"
                 (click)="selectSection(section.key)"
                 [ngClass]="{ 'active-sect-item': selected === section.key }">

              <div class="icons_white">
                <img [src]="section.icon" alt="icon" class="filter">
              </div>

              <h4>{{ section.text }}</h4>
            </div>
          }

        </div>
      </div>
    </div>
  </div>
</section>


<div class="content">

  <div [hidden]="selected !== 'consultoria'">
    <app-consulting-proyect></app-consulting-proyect>
  </div>

  <div [hidden]="selected !== 'movil'">
    <app-digital-growth-project></app-digital-growth-project>
  </div>

  <div [hidden]="selected !== 'software'">
    <app-digital-experience-project></app-digital-experience-project>
  </div>

</div>